import React from "react";

const Toolbar = ({
  showFavorites,
  toggleShowFavorites,
  sortOrder,
  handleSortChange,
}) => {
  return (
    <div className="toolbar flex justify-center gap-4 my-2">
      <select
        onChange={toggleShowFavorites}
        className="p-2 border rounded"
        defaultValue={showFavorites}
      >
        <option value={false}>Näytä kaikki</option>
        <option value={true}>Näytä suosikit</option>
      </select>
      <select
        value={sortOrder}
        onChange={handleSortChange}
        className="p-2 border rounded"
      >
        <option value="highest">Korkein lämpötila ensin</option>
        <option value="lowest">Matalin lämpötila ensin</option>
        <option value="alphabetical">Aakkosjärjestys</option>
        <option value="lastUpdated">Viimeksi päivitetty</option>
      </select>
    </div>
  );
};

export default Toolbar;
